import { getLocale, translate } from '@/i18n';
import { SITE_ORIGIN, localizedPath, SOCIAL_IMAGE_URL } from '@/seoConfig';

function link(rel, href, hreflang) {
  const selector = `link[rel="${rel}"]${hreflang ? `[hreflang="${hreflang}"]` : ''}`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('link');
    element.rel = rel;
    if (hreflang) element.hreflang = hreflang;
    document.head.appendChild(element);
  }
  element.href = href;
}

function meta(attribute, name, content) {
  let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.content = content;
}

/** Updates shared metadata on navigation and locale changes. */
export function updatePageSeo(route, { name, description, image, notFound = false } = {}) {
  const title = notFound ? translate('notFound.title')
    : route.name === 'Home' ? translate('seo.homeTitle')
    : route.meta?.titleKey ? translate(route.meta.titleKey) : route.meta?.title;
  const titleSection = route.name === 'ClubHome' && name && !notFound ? null : title;
  document.title = [name, titleSection, 'Bar Chess Manager'].filter(Boolean).join(' — ');
  const pageDescription = notFound ? translate('notFound.description') : description || (name
    ? translate('seo.entity', { name, section: title || 'Bar Chess Manager' })
    : translate(`seo.${({
    Home: 'home', Features: 'features', Pricing: 'pricing', About: 'about', AllClubs: 'clubs', Changelog: 'changelog', Chess: 'chess',
  })[route.name] || 'default'}`));
  const noindex = notFound || route.meta?.requiresAuth || route.meta?.noindex || route.meta?.title === '404'
    || route.name === 'PublicSearch';
  meta('name', 'description', pageDescription);
  meta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');
  meta('property', 'og:type', 'website');
  meta('property', 'og:site_name', 'Bar Chess Manager');
  meta('property', 'og:title', document.title);
  meta('property', 'og:description', pageDescription);
  meta('property', 'og:locale', getLocale() === 'ru' ? 'ru_RU' : 'en_US');
  meta('name', 'twitter:card', 'summary_large_image');
  meta('name', 'twitter:title', document.title);
  meta('name', 'twitter:description', pageDescription);
  const path = (route.path || '/').replace(/\/+$/, '') || '/';
  const canonical = `${SITE_ORIGIN}${localizedPath(path, getLocale())}`;
  if (noindex) {
    document.head.querySelectorAll('link[rel="canonical"], meta[property="og:url"]').forEach(element => element.remove());
  } else {
    link('canonical', canonical);
    meta('property', 'og:url', canonical);
  }
  document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach(element => element.remove());
  if (!noindex) {
    for (const locale of ['en', 'ru']) {
      link('alternate', `${SITE_ORIGIN}${localizedPath(path, locale)}`, locale);
    }
    link('alternate', `${SITE_ORIGIN}${localizedPath(path, 'en')}`, 'x-default');
  }
  meta('property', 'og:image', notFound ? SOCIAL_IMAGE_URL : image || SOCIAL_IMAGE_URL);
  meta('name', 'twitter:image', notFound ? SOCIAL_IMAGE_URL : image || SOCIAL_IMAGE_URL);
}
